/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Grid, IconButton, Paper } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { deleteImage } from "app/redux/slice/invoiceSlice";
import { useEffect, useState } from "react";
import { getByIdMillOrder } from "app/redux/slice/millOrderSlice";

const FilePreview = ({ value, handleSubmit }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [orderData, setOrderData] = useState([]);

  const validationSchema = Yup.object({
    // status: Yup.string().required("Please enter vendor"),
    // markaNumber: Yup.string().required("Please enter marka number"),
    // file: Yup.mixed().required("A file is required"),
  });

  const handleDelete = (filename) => {
    dispatch(
      deleteImage({
        filename,
        type: "mill-order",
        id: value?._id,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          dispatch(getByIdMillOrder(value?._id))
            .unwrap()
            .then((response) => {
              if (response.status === 200) {
                setOrderData(response?.data?.data?.millOrderDetail);
              } else {
                enqueueSnackbar(response.data?.responseMessage, {
                  variant: "error",
                });
              }
            });
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  useEffect(() => {
    dispatch(getByIdMillOrder(value?._id))
      .unwrap()
      .then((response) => {
        if (response.status === 200) {
          setOrderData(response?.data?.data?.millOrderDetail);
        } else {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  }, [dispatch, enqueueSnackbar]);

  return (
    <>
      <Formik
        initialValues={{
          status: "",
          files: null,
          markaNumber: orderData?.markaNumber,
        }}
        validationSchema={validationSchema}
        onSubmit={async (data, { setSubmitting }) => {
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1500);
        }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            {orderData?.statusImage?.length < 1 && <h3>No data available</h3>}
            {orderData?.statusImage?.length > 0 && (
              <>
                <Grid container spacing={2} mb={4}>
                  {orderData?.statusImage?.map((img, index) => (
                    <Grid item sm={4} xs={12} key={index}>
                      <Paper
                        elevation={3}
                        style={{
                          position: "relative",
                          borderRadius: "10px",
                          overflow: "hidden",
                          minWidth: "200px",
                        }}
                      >
                        <IconButton
                          aria-label="delete"
                          style={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            backgroundColor: "rgba(255,255,255,0.8)",
                          }}
                          size="small"
                        >
                          <DeleteIcon
                            onClick={() => handleDelete(img)}
                            fontSize="small"
                          />
                        </IconButton>
                        {img.endsWith(".pdf") ? (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}mill-order-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                              }}
                            >
                              <Icon
                                icon="fa6-regular:file-pdf"
                                width="100%"
                                height="100px"
                                style={{ color: "#000" }}
                              />
                            </div>
                          </a>
                        ) : (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}mill-order-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_BASE_URL}mill-order-images/${img}`}
                              alt={`Invoice ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "block",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </a>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FilePreview;
